export type SecondaryDimensionValues =
  | 'timeseries'
  | 'rics'
  | 'geography'
  | 'role'
  | 'company'
  | 'skills'
  | 'activities'
  | 'gender'
  | 'ethnicity'
  | 'education'
  | 'seniority'
  | 'competitors'
  | 'subsidiaries';

export const DASHBOARD_ENTITY_TYPES = [
  'company',
  'industry',
  'geography',
  'role',
  'skill',
  'activity',
] as const;

export type EntityType = (typeof DASHBOARD_ENTITY_TYPES)[number];

/**
 * The breakdown dimension that IS the page entity, used to keep an entity from
 * breaking itself down.
 */
export type PrimaryDimensionValue = Extract<
  SecondaryDimensionValues,
  'company' | 'rics' | 'geography' | 'role' | 'skills' | 'activities'
>;

export function getPrimaryDimensionForEntityType(
  entityType: EntityType
): PrimaryDimensionValue {
  if (entityType === 'industry') return 'rics';
  if (entityType === 'skill') return 'skills';
  if (entityType === 'activity') return 'activities';
  return entityType;
}

export type SecondaryDimensionOption = {
  value: SecondaryDimensionValues;
  label: string;
};

export const secondaryDimensionOptions: SecondaryDimensionOption[] = [
  { value: 'timeseries', label: 'Timeseries' },
  { value: 'competitors', label: 'Competitors' },
  { value: 'rics', label: 'Industry' },
  { value: 'geography', label: 'Geography' },
  { value: 'role', label: 'Role' },
  { value: 'company', label: 'Company' },
  { value: 'skills', label: 'Skill' },
  { value: 'activities', label: 'Activity' },
  { value: 'gender', label: 'Gender' },
  { value: 'ethnicity', label: 'Ethnicity' },
  { value: 'education', label: 'Education' },
  { value: 'seniority', label: 'Seniority' },
  { value: 'subsidiaries', label: 'Subsidiaries' },
];
